import { createApi } from '@reduxjs/toolkit/query/react';
import { backend_server_address } from '../../../backendServer';
import { axiosBaseQuery } from '../../../store/utility';

export const authAPI = createApi({
    reducerPath: 'authAPI',
    baseQuery: axiosBaseQuery({ baseUrl: `${backend_server_address}/api/login/` }),
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: 'token2/',
                method: 'POST',
                withCredentials: true,
                data,
            }),
        }),
        refreshToken: builder.mutation({
            query: () => ({
                url: 'token2/refresh/',
                method: 'POST',
                withCredentials: true,
            }),
        }),
        deleteToken: builder.mutation<void, void>({
            query: () => ({
                url: 'token2/delete/',
                method: 'POST',
                withCredentials: true,
            }),
        }),
        changePassword: builder.mutation({
            query: (data) => ({
                url: 'user/change_password/',
                method: 'POST',
                withCredentials: true,
                data,
            }),
        }),
        recoverPassword: builder.mutation({
            query: (data) => ({
                url: 'user/recover_password/',
                method: 'POST',
                withCredentials: true,
                data,
            }),
        }),
    }),
});

export const {
    endpoints,
    useLoginMutation,
    useRefreshTokenMutation,
    useDeleteTokenMutation,
    useChangePasswordMutation,
    useRecoverPasswordMutation,
} = authAPI;
export const authAPIReducer = authAPI.reducer;
export const authAPIReducerPath = authAPI.reducerPath;
export const authAPIReducerMiddleware = authAPI.middleware;

/**
 * The URL to send the user to after login when the login page was opened with
 * `?next=`, or null. Only an absolute URL on the backend's origin qualifies: the
 * MCP consent bridge (`/api/mcp/consent/session-bridge/`) opens the SPA login this
 * way and needs the browser back on the API host once the JWT cookie exists.
 */
export const consentReturnUrl = (search: string): string | null => {
    const next = new URLSearchParams(search).get('next');
    if (!next) return null;
    try {
        return new URL(next).origin === new URL(backend_server_address ?? '').origin ? next : null;
    } catch {
        return null;
    }
};

export const redirectToSso = (provider: string, params?: Record<string, string>) => {
    let baseUrl = `${backend_server_address}/api/login/social/${provider}/redirect/`;
    if (params) {
        const searchParams = new URLSearchParams(params);
        baseUrl += `?${searchParams.toString()}`;
    }
    globalThis.location.href = baseUrl;
};
